import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ServiceCard = ({ image, header, description, link }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col overflow-hidden shadow-md rounded-2xl">
      <img src={image} alt="Service" className="object-cover w-full h-48" />
      <div className="flex flex-col flex-1 p-4 ">
        <h2 className="text-2xl font-bold">{header}</h2>
        <p className="my-4 text-lg text-mainGray">{description}</p>
        <Link
          to={link}
          className="block !mt-auto font-bold underline uppercase underline-offset-2 text-mainRed"
        >
          {t("ReadMore")}
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard;
